// extracted by mini-css-extract-plugin
export default {"link":"FD-z","disabled":"GD-z"};